/* Collection Redesign 2025 - SP modal & filter count
   Interacts with existing <facet-filters-form> (assets/facets.js) by dispatching a submit event. */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.cr2025');
    if (!root) return;

    var sidebar = root.querySelector('#CR2025Filter');
    var form = root.querySelector('#CR2025FilterForm');
    var countEl = root.querySelector('[data-cr2025-count]');

    /* ── SP モーダル開閉 ── */
    function openModal() {
      if (!sidebar) return;
      sidebar.classList.add('is-open');
      document.body.classList.add('cr2025-modal-open');
      var firstInput = sidebar.querySelector('input, button');
      if (firstInput) firstInput.focus();
    }

    function closeModal() {
      if (!sidebar) return;
      sidebar.classList.remove('is-open');
      document.body.classList.remove('cr2025-modal-open');
    }

    /* イベント委譲: DOM入れ替え後もボタンのクリックを捕捉 */
    document.addEventListener('click', function (e) {
      /* 開くボタン */
      if (e.target.closest('[data-cr2025-open]')) {
        openModal();
        return;
      }
      /* 閉じるボタン */
      if (e.target.closest('[data-cr2025-close]')) {
        closeModal();
        return;
      }
      /* リセットボタン */
      if (e.target.closest('[data-cr2025-reset]')) {
        if (form) {
          var checks = form.querySelectorAll('input[type="checkbox"]');
          checks.forEach(function (c) { c.checked = false; });
          updateCount();
        }
        window.location.href = (form && form.getAttribute('action')) || window.location.pathname;
        return;
      }
      /* 背景クリックで閉じる (パネル内クリックは無視) */
      if (sidebar && sidebar.classList.contains('is-open')) {
        var panel = sidebar.querySelector('.cr2025-sidebar__panel');
        if (panel && !panel.contains(e.target) && !e.target.closest('[data-cr2025-open]')) {
          closeModal();
        }
      }
    });

    /* Escape key to close modal */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sidebar && sidebar.classList.contains('is-open')) {
        closeModal();
      }
    });

    /* ── 絞り込み件数表示 ── */
    function updateCount() {
      if (!countEl || !form) return;
      var checked = form.querySelectorAll('input[type="checkbox"]:checked').length;
      countEl.textContent = '(' + checked + ')';
    }

    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'checkbox') updateCount();
      });
      updateCount();
    }

    /* ── Sort select: facets.js が submit イベントを拾ってくれるため form.requestSubmit() で発火 ── */
    /* イベント委譲: Ajax後にselectが再生成されても動作するよう document に登録 */
    document.addEventListener('change', function (e) {
      var sortSelect = e.target.closest('#CR2025SortBy');
      if (!sortSelect) return;
      var sortForm = sortSelect.form;
      if (!sortForm) return;
      if (typeof sortForm.requestSubmit === 'function') {
        sortForm.requestSubmit();
      } else {
        var evt = new Event('submit', { bubbles: true, cancelable: true });
        sortForm.dispatchEvent(evt);
      }
    });

/* ── フィルター排他制御ヘルパー ── */

    function getCollectionResetUrl() {
      var handle = (root && root.getAttribute('data-collection-handle')) || '';
      if (handle.indexOf('-pro') !== -1 || handle === 'proposal') return '/collections/proposal';
      if (handle.indexOf('-aniv') !== -1 || handle === 'anniversary') return '/collections/anniversary';
      return '/collections/wedding';
    }

    function removeFilterParams(url, paramNames) {
      try {
        var u = new URL(url, window.location.origin);
        paramNames.forEach(function (name) { u.searchParams.delete(name); });
        return u.pathname + (u.search ? u.search : '');
      } catch (e) { return url; }
    }

    function clearCheckboxesByName(filterForm, name) {
      filterForm.querySelectorAll('input[type="checkbox"][name="' + name + '"]').forEach(function (cb) {
        cb.checked = false;
        var chip = cb.closest('.cr2025-layout, .cr2025-chip');
        if (chip) {
          chip.setAttribute('aria-checked', 'false');
          chip.classList.remove('is-on');
        }
      });
    }

    /* ── 「可能なレイアウト」選択: 仕上がりをリセット→排他選択→submit ── */
    document.addEventListener('change', function (e) {
      var layoutInput = e.target.closest('.cr2025-layout input[type="checkbox"]');
      if (!layoutInput) return;
      var filterForm = layoutInput.closest('#CR2025FilterForm');
      if (!filterForm) return;

      // 他のレイアウトチェックボックスを外す（排他）
      filterForm.querySelectorAll('.cr2025-layout input[type="checkbox"]').forEach(function (cb) {
        if (cb === layoutInput) return;
        cb.checked = false;
        var chip = cb.closest('.cr2025-layout');
        if (chip) { chip.setAttribute('aria-checked', 'false'); chip.classList.remove('is-on'); }
      });

      // 仕上がり（filter.p.product_type）をリセット
      clearCheckboxesByName(filterForm, 'filter.p.product_type');

      if (typeof filterForm.requestSubmit === 'function') {
        filterForm.requestSubmit();
      } else {
        filterForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });

    /* ── 「仕上がり」（cr2025-chip）選択: 可能なレイアウトをリセットしてリンク遷移 ── */
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('.cr2025-chip');
      if (!chip) return;
      var href = chip.getAttribute('href');
      if (!href) return;
      var cleanHref = removeFilterParams(href, ['filter.p.m.custom.layout']);
      if (cleanHref !== href) {
        e.preventDefault();
        window.location.href = cleanHref;
      }
    });

    /* ── 「額のサイズ」（cr2025-sizecell）選択: 仕上がり・レイアウトをリセットして遷移 ── */
    document.addEventListener('click', function (e) {
      var cell = e.target.closest('.cr2025-sizecell');
      if (!cell) return;
      var href = cell.getAttribute('href');
      if (!href) return;
      e.preventDefault();

      if (cell.classList.contains('is-active')) {
        window.location.href = getCollectionResetUrl();
        return;
      }

      var cleanHref = removeFilterParams(href, ['filter.p.product_type', 'filter.p.m.custom.layout']);
      window.location.href = cleanHref;
    });

    /* ── Chipラベルのキーボード操作 (space/enter) ── */
    document.addEventListener('keydown', function (e) {
      var chip = e.target.closest('.cr2025-chip, .cr2025-layout');
      if (!chip) return;
      if (e.key === ' ' || e.key === 'Enter') {
        var input = chip.querySelector('input[type="checkbox"]');
        if (input) {
          e.preventDefault();
          input.checked = !input.checked;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    /* chip の aria-checked 同期 */
    if (root) {
      root.addEventListener('change', function (e) {
        var input = e.target;
        if (!input || input.type !== 'checkbox') return;
        var chip = input.closest('.cr2025-chip, .cr2025-layout');
        if (chip) {
          chip.setAttribute('aria-checked', input.checked ? 'true' : 'false');
          chip.classList.toggle('is-on', input.checked);
        }
      });

      /* 初期 aria-checked 設定 */
      root.querySelectorAll('.cr2025-chip, .cr2025-layout').forEach(function (chip) {
        chip.setAttribute('tabindex', '0');
        chip.setAttribute('role', 'checkbox');
        var input = chip.querySelector('input[type="checkbox"]');
        if (input) chip.setAttribute('aria-checked', input.checked ? 'true' : 'false');
      });
    }
  });

})();
